import "@mui/lab/themeAugmentation";

import { createTheme as createMuiTheme, PaletteOptions } from "@mui/material/styles";
import variants from "@/theme/variants";
import typography from "@/theme/typography";
import breakpoints from "@/theme/breakpoints";
import components from "@/theme/components";
import shadows from "@/theme/shadows";

const createTheme = (themeConfig: any) => {
  // let themeConfig = variants.find((variant) => variant.name === name);

  // if (!themeConfig) {
  //   console.warn(new Error(`The theme ${name} is not valid`));
  //   themeConfig = variants[0];
  // }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints: breakpoints,
      // @ts-expect-error Incompatible types
      components: components,
      typography: typography,
      shadows: shadows,
      palette: themeConfig.palette,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    }
  );
};

export default createTheme;
